import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../../config/config'
import logger from "vuex/dist/logger";

function initialState() {
    return {
        visaNumber: 123,
        extra_data: [],
        visa: {
            traveller: {
                full_name: null
            },
            passport: {},
            extra: {
                address: {},
                application_data: {}
            },
            price: null,
            condition: null,
            visaPlan: 3,
            duration: null,
            documents: [],
            visa_type: null,
            visa_type_condition: null,
            online_payment:0,
            apply_type:'embassy',
            office:null,
        },
        extendConvertData: {
            changeTo: null,
            passport_number: null,
            condition: null,
            documents: [],
            price: null,
            visaPlan: 3,
            type: null,
            duration: null,
            reason: '',
            start_date: new Date().toISOString().substr(0, 10)
        },
        visaCatOptions: [{
                text: "Plain",
                value: 1
            },
            {
                text: "Single Rentry",
                value: 2
            },
            {
                text: "Multiple Rentry",
                value: 3
            }
        ],
        purposeAutoCompletes: [],
        occupationOptions: [
            "Doctor",
            "Engineer",
            "Government Service",
            "Driver",
            "Foreign Employment",
            "Advocate",
            "Journalist",
            "IT Professional",
            "Student",
            "Other"
        ],
        extendTime: null,
        price: null,
        days: null,
        loading: false,
        pdfDetails: [],
        documents: [],
        extendConvertResponse: {},
        extendConvertVisaDetail: {},
        dependentVisaDetail: null,
        arrivalDepartureCertification: {
            image: null,
            date: null,
            purpose_of_visit: null,
            office: null,
            cost: null,
            country: null,
        },
        visaTransferData: {
            document_type: 'Document',
            document_number: '',
            document_validity: null,
            reason_for_transfer: null,
            document_file: null,
            attached_document: null
        },
        printResponse: {},
        convert_visa_options: [],
        apply_type: 'online',
        office: ''
    }
}

const getters = {
    loading: state => state.loading,
    visaFetched: state => state.visaFetched,
    visa: state => state.visa,
    visaNumber: state => state.visaNumber,
    pdfDetails: state => state.pdfDetails,
    purposeAutoCompletes: state => state.purposeAutoCompletes,
    occupationOptions: state => state.occupationOptions,
    visaCatOptions: state => state.visaCatOptions,
    price: state => state.price,
    extra_data: state => state.extra_data,
    extendConvertData: state => state.extendConvertData,
    days: state => state.days,
    extendConvertVisaDetail: state => state.extendConvertVisaDetail,
    convert_visa_options: state => state.convert_visa_options,
    arrivalDepartureCertification: state => state.arrivalDepartureCertification,
    dependentVisaDetail: state => state.dependentVisaDetail,
    printResponse: state => state.printResponse,
    visaTransferData: state => state.visaTransferData,
    apply_type: state => state.apply_type,
    office: state => state.office
};

const actions = {
    resetState({
        commit
    }) {
        commit('resetState')
    },
    saveVisa({
        commit,
        state
    }) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            let data = new FormData();
            buildFormData(data, state.visa);
            let office = state.office;
            if (office === 'tia-online') {
                office = 'tia'
            }
            data.append('office', office);
            Http.post(API_URL + VERSION + '/embassy/save-visa-application', data)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },

    submitArrivalCertification({
        state,
        commit
    }) {
        let formData = new FormData();

        buildFormData(formData, state.arrivalDepartureCertification);
        formData.append('token', state.extendConvertVisaDetail.access_token);
        formData.append('visa_number', state.extendConvertVisaDetail.visa_number);
        return new Promise(((resolve, reject) => {
            Http.post(API_URL + VERSION + '/request-arrival-departure-certification', formData).then((res) => {
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        }));
    },
    submitExtendVisa({
        state,
        commit
    }, data) {
        let formData = new FormData();
        let send_data = {
            token: state.extendConvertVisaDetail.access_token,
            visa_number: state.extendConvertVisaDetail.visa_number,
            extend_time: data.extend_time,
            passport_number: state.extendConvertVisaDetail.passport_number,
            reason: data.reason,
            documents: state.extendConvertData.documents
        };
        buildFormData(formData, send_data);
        return new Promise((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/request-extend-visa`, formData).then((response) => {
                // commit('resetState');
                commit('setPrintResponse', response.data);
                resolve(true)
            }).catch((error) => {
                console.log(error);
                reject(error)
            })
        });
    },
    submitConvertVisa({
        state,
        commit
    }, data) {

        let formData = new FormData();
        let send_data = state.visa.extra.application_data;
        send_data.token = state.extendConvertVisaDetail.access_token;
        send_data.visa_number = state.extendConvertVisaDetail.visa_number;
        send_data.days_staying = state.extendConvertData.days_staying;
        send_data.visa_plan = state.extendConvertData.visaPlan;
        send_data.purpose_of_visa = state.extendConvertData.purpose_of_visa;
        send_data.documents = state.extendConvertData.documents;
        send_data.exchange_type = state.extendConvertData.condition;
        send_data.passport_number = state.extendConvertVisaDetail.passport_number;
        send_data.start_date = state.extendConvertData.start_date;
        if (state.dependentVisaDetail) {
            send_data.dependent_visa_number = state.dependentVisaDetail.visa_number;
            send_data.dependent_passport_number = state.dependentVisaDetail.passport_number;
        }
        buildFormData(formData, send_data);

        return new Promise((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/request-convert-visa`, formData).then((response) => {
                // commit('resetState');
                commit('setPrintResponse', response.data);
                resolve(true);
            }).catch((error) => {
                reject(error)
            })
        })
    },
    submitTransferVisa({
        commit,
        state
    }, data) {
        commit('setLoading', true);
        let formData = new FormData();
        buildFormData(formData, state.visaTransferData);
        formData.append('token', state.extendConvertVisaDetail.access_token);
        formData.append('visa_number', state.extendConvertVisaDetail.visa_number);
        return new Promise(((resolve, reject) => {
            Http.post(API_URL + VERSION + '/request-for-transfer', formData).then((res) => {
                commit('setLoading', false);
                resolve(res)
            }).catch((err) => {
                commit('setLoading', false);
                reject(err)
            })

        }));
    },
    searchForVisa({
        commit,
        state
    }, data) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/search-visa?visa_number=' + data.visa_number + '&passport_number=' + data.passport_number + '&passport_type=' + data.passport_type)
                .then(response => {
                    state.extendConvertVisaDetail = response.data.visa_detail;
                    state.convert_visa_options = response.data.convert_visa_types;
                    commit("setArrivalStartDate");
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },

    async searchForTravellerIfAny({state, commit }, input_data) {
        commit('setLoading', true);
        try {
            let { data } = await Http.get(API_URL + VERSION + '/search-visa-if-any', {
                params: input_data
            });
            commit('setVisaIfTraveller', data.data);
            commit('setLoading', false);
        } catch (e) {
            commit('setLoading', false);
            throw e;
        }
    },

    checkVisaStatus({ state }) {
        return new Promise((resolve, reject) => {
            Http.get(API_URL + VERSION + '/check-traveller-status', {
                params: {
                    dob: state.visa.traveller.dob,
                    full_name: state.visa.traveller.full_name,
                    passport_number: state.visa.passport.passport_number,
                    passport_type: state.visa.passport.passport_type,
                    country: state.visa.traveller.country,
                    days: state.days,
                    visa_type_condition: state.visa.condition
                }
            }).then((res) => {
                resolve(res.data);
            }).catch((err) => {
                reject(err)
            });
        })
    },
    getDependentVisaDetail({
        commit,
        state
    }, data) {
        commit('setLoading', true);
        return new Promise(((resolve, reject) => {
            Http.get(API_URL + VERSION + '/visa-dependent-detail', {
                params: {
                    visa_number: state.visa.extra.application_data.dependent_visa_number,
                    passport_number: state.visa.extra.application_data.dependent_passport_number,
                }
            }).then((response) => {
                commit('setDependentVisaDetails', response.data);
                commit('setLoading', false);

                response(response)
            }).catch((error) => {
                reject(error);
                commit('setLoading', false);
            })
        }));
    },
    getVisaPurposes({
        commit,
        state
    }, data) {
        commit('setLoading', true);
        return new Promise(((resolve, reject) => {
            Http.get(API_URL + VERSION + '/dynamic-values-setup/fetch-all', {
                params: {
                    key: 'PurposeOfVisa',
                }
            }).then((response) => {
                let res = response.data.data;
                res.forEach(function(val, index) {
                    state.purposeAutoCompletes.push(val.value.name)
                });
                // commit('purposeAutoCompletes', response.data);
                commit('setLoading', false);

                resolve(response)
            }).catch((error) => {
                reject(error);
                commit('setLoading', false);
            })
        }));
    }
};

const mutations = {
    setVisa(state, items) {
        state.visa = items;
    },
    setExtraData(state, items) {
        state.extra_data = items;
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setPdfDetails(state, pdfDetails) {
        state.pdfDetails = pdfDetails;
    },
    setPrintResponse(state, items) {
        state.printResponse = items;
    },
    setExtendPassportNumber(state, passport_number) {
        state.extendPassportNumber = passport_number;
    },
    setPrice(state, item) {
        state.price = item.cost;
        state.days = item.days;
        state.visa.price = item.cost;
    },
    setArrivalStartDate(state) {
        let today_date = new Date();
        today_date.setDate(today_date.getDate() - 2);
        state.arrivalDepartureCertification.date = today_date.toISOString().substr(0, 10);
    },
    setVisaType(sate, item) {
        state.visa.visa_type = item;
    },
    setDependentVisaDetails(state, item) {
        state.dependentVisaDetail = item;
    },
    setVisaTypeCondition(sate, item) {
        state.visa.visa_type_condition = item;
    },
    setArrivalCertificationPrintContent(state, item) {
        state.arrivalCertificationData = item;
    },
    setApplyType(state, apply_type) {
        state.apply_type = apply_type;
    },
    setDocuments(state) {
        let conditions = this.getters['VisaTypeSingle/conditions'];
        let condition = conditions.find(i => i.id === state.extendConvertData.condition);

        state.extendConvertData.documents = condition.document_types.filter((i) => i.show_front === 1).map((i) => {
            return {
                id: i.id,
                name: i.name,
                remarks: i.remarks,
                required: i.required,
                label: i.name + ((i.required === 1) ? " number * " : " number "),
                file: null,
                number: null
            }
        });
        this.commit('VisaSingle/calculateExtendPrice');
    },
    setOffice(state, office) {
        state.office = office;
    },
    setLastArrivalCountry(state, country) {
        state.visa.last_arriving_country = country;
    },
    setPassportNumber(state, no) {
        state.visa.passport.passport_number = no;
    },
    setDOB(state, dob) {
        state.visa.traveller.dob = dob;
    },
    setVisaIfTraveller(state, data) {
        const visa = JSON.parse(JSON.stringify(state.visa));
        visa.passport = data.passport;
        visa.traveller = data.traveller;
        state.visa = visa;
    },

};

function buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach(key => {
            buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
        });
    } else {
        const value = data == null ? '' : data;
        formData.append(parentKey, value);
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
